import React, { Component } from "react";
import { Carousel } from "antd";
import { connect } from "react-redux";
import Loading from "../common/Loading";
import Alert from "../common/Alert";

export class SiderBanner extends Component {
  render() {
    const {
      promotionalBannersError,
      loadingBanners,
      promotionalBanners,
    } = this.props;

    const betSlipWebsiteBannerImages =
      promotionalBanners && promotionalBanners.betSlipWebsiteBannerImages;
    return (
      <>
        <Carousel
          effect="fade"
          dots={true}
          dotPosition={"bottom"}
          infinite={true}
          autoplay
        >
          {loadingBanners ? (
            <Loading />
          ) : promotionalBannersError ? (
            <Alert type="error" message={promotionalBannersError} />
          ) : betSlipWebsiteBannerImages ? (
            betSlipWebsiteBannerImages.map((item) => {
              return (
                <div>
                  <img
                    style={{
                      width: "100%",
                      borderRadius: "5px",
                      maxHeight: "320px",
                    }}
                    src={
                      "https://dev-fr.winners.com.lr/api/general/image/Website/MobileBanners/NumberOne.webp"
                    }
                    alt="banner"
                  />
                </div>
              );
            })
          ) : (
            ""
          )}
        </Carousel>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    promotionalBannersError: state.general.promotionalBannersError,
    loadingBanners: state.general.loadingBanners,
    promotionalBanners: state.general.promotionalBanners,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SiderBanner);
